import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {castToSend} from 'common/yup/castToSend';
import Dialog from 'components/Dialog';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {
   IScheduledReportsParameters,
   ScheduledReportsParameters,
} from 'types/diplomat/reports/ScheduledReportsParameters';
import AddEditScheduledReportForm from './AddEditScheduledReportForm';

type Props = {
   onClose: () => void;
   onSubmit: (
      values: IScheduledReportsParameters,
      formikBag: FormOnSubmitHelpers<IScheduledReportsParameters>
   ) => void;
   scheduledReport?: IScheduledReportsParameters;
};
const AddEditScheduledReport = memo(({onClose, onSubmit: _onSubmit, scheduledReport}: Props) => {
   const {t} = useTranslation();

   const header = scheduledReport ? t('Edit Scheduled Report') : t('Add Scheduled Report');

   const {request: getDefaultDir, state: defaultDir} = useGetApi<{defaultDirectory: string}>(
      api.defaultdir
   );
   React.useEffect(() => {
      getDefaultDir();
   }, [getDefaultDir]);

   const values = React.useMemo(
      () =>
         ScheduledReportsParameters.cast(
            scheduledReport || {
               location: {
                  dirTemplate: defaultDir?.defaultDirectory,
               },
            }
         ),
      [scheduledReport, defaultDir]
   );

   const onSubmit = (
      values: IScheduledReportsParameters,
      formikBag: FormOnSubmitHelpers<IScheduledReportsParameters>
   ) => {
      // console.debug(values);
      return _onSubmit(castToSend(ScheduledReportsParameters, values), formikBag);
   };

   return (
      <Dialog header={header} close={onClose}>
         {/* {JSON.stringify(scheduledReport)} */}
         <Formik
            initialValues={values}
            enableReinitialize
            validationSchema={ScheduledReportsParameters}
            onSubmit={onSubmit}
         >
            <AddEditScheduledReportForm onClose={onClose} />
         </Formik>
      </Dialog>
   );
});

export default AddEditScheduledReport;
